<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'training.blogs' }"
        >
          Student Leader Training Blogs
        </router-link>
        <v-icon> {{ icons.arrow }} </v-icon>
        <span>Create</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4">
      <blog-form ref="form" @save="saveBlog" />
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import BlogForm from '@/components/BlogForm'
import { each } from 'lodash'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import * as BlogType from '@/utils/consts/BlogType'

export default {
  name: 'CreateNews',

  components: {
    BlogForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      form: {
        title: '',
        subtitle: '',
        content: '',
        cover: null
      }
    }
  },

  methods: {
    saveBlog(form) {
      const formData = new FormData()
      formData.append('type', BlogType.TRAINING)
      each(form, (value, key) => {
        if (value !== null) {
          formData.append(key, value)
        }
      })
      this.$api
        .post('/blogs', formData)
        .then(response => {
          this.$toast('Blog successfully created!', {
            color: 'green'
          })
          this.$router.replace({ name: 'training.blogs' })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.$refs.form.setLoading(false)
        })
    }
  }
}
</script>
